import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Music2 } from "lucide-react";
import AlbumArt from "../components/AlbumArt";

export default function Music() {
  const [tracks, setTracks] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/tracks").then(({ data }) => setTracks(data));
  }, []);

  const albums = useMemo(() => {
    const map = new Map();
    for (const t of tracks) {
      const key = `${t.artist}|||${t.album}`;
      if (!map.has(key)) map.set(key, { artist: t.artist, album: t.album, album_art_url: t.album_art_url, count: 0 });
      map.get(key).count += 1;
    }
    return Array.from(map.values()).sort((a, b) => a.artist.localeCompare(b.artist) || a.album.localeCompare(b.album));
  }, [tracks]);

  if (tracks.length === 0) {
    return (
      <div className="min-h-screen bg-[#050505] pt-32 pb-24" data-testid="music-empty-page">
        <div className="px-6 md:px-12 max-w-[1500px] mx-auto text-center">
          <Music2 size={48} strokeWidth={1.5} className="mx-auto text-[#8A8A8A]" />
          <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-white">No music yet</h1>
          <p className="text-[#8A8A8A] mt-3 max-w-md mx-auto">Run a Library Scan in Admin to import tracks from the NAS.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] pt-32 pb-24" data-testid="music-page">
      <div className="px-6 md:px-12 max-w-[1500px] mx-auto">
        <span className="text-xs uppercase tracking-[0.3em] text-[#D9381E]">Music</span>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter text-white mt-3">Your Music</h1>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
          {albums.map((a) => (
            <button key={`${a.artist}|||${a.album}`}
              onClick={() => nav(`/music/album/${encodeURIComponent(a.artist)}/${encodeURIComponent(a.album)}`)}
              className="group relative aspect-square overflow-hidden bg-[#0F0F0F] transition-transform duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#D9381E]"
              data-testid={`album-card-${a.artist}-${a.album}`}>
              <AlbumArt url={a.album_art_url} />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-sm truncate">{a.album}</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#8A8A8A] truncate">{a.artist} · {a.count} tracks</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
